<idp-accordion
  class="skymiles-landing-page-menu__sections__accordion"
  *ngIf="details.items.length > 1"
  [caretType]="'tertiary'"
  [showLabel]="false"
  [state]="false"
  [type]="'tertiary'"
  targetContent="content_details_body"
></idp-accordion>
<div
  [ngClass]="{
    'skymiles-landing-page-menu__section-header-active':
      details.opened && details.items.length === 0
  }"
>
  <idp-section-header [details]="details"></idp-section-header>
</div>
<div [hidden]="!details.opened">
  <div *ngFor="let item of details.items; let linkIndex = index">
    <idp-section-item
      [item]="item"
      (listItem)="listItem.emit(item.link)"
      [indexValue]="linkIndex"
      [lengthOfItem]="details.items.length"
    ></idp-section-item>
  </div>
</div>
